import { Dispatch } from "redux";
import { types } from "../types/types";

export const setUserAuthTokens = (jwt: string, refreshToken?: string) => {
  return {
    type: types.user,
    payload: {
      jwt,
      refreshToken,
      tempToken: "",
    },
  };
};

export const local = (user: any) => {

  // eslint-disable-next-line no-param-reassign
  delete user.password;
  return {
    type: types.userDt,
    payload: {
      user,
    },
  };
};

export const setTempToken = (tempToken: string) => {
  return {
    type: types.setTempToken,
    payload: {
      tempToken,
    },
  };
};

export const logout = () => (dispatch: Dispatch) => {
  dispatch({
    type: types.logout,
  });
  dispatch({
    type: types.financialFormRemove,
  });
};
